import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { ButtonWithIcon } from '@els/els-react--button';
import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import Pagination from '@Containers/ResultsFilters/ResultsFiltersComponents/NewAuthorCheckboxesDialog/Components/Pagination';

function DialogFooter({
  id,
  filter,
  chunksCount,
  activeChunkIndexAsInteger,
  setActiveChunkId,
  onClickLimitTo,
  onClickExclude,
  disableLimitTo,
  disableExclude,
  sortingType,
  customGroups,
  onClickGoToButton,
}) {
  return chunksCount ? (
    <>
      {(!customGroups || sortingType !== byValue) && (
        <Pagination
          id={id}
          chunksCount={chunksCount}
          setActiveChunkId={setActiveChunkId}
          activeChunkIndexAsInteger={activeChunkIndexAsInteger}
          onClickGoToButton={onClickGoToButton}
          filter={filter}
        />
      )}
      <div className="new-author-checkboxes-dialog__buttons">
        <ButtonWithIcon
          size="small"
          sprite="ChevronRight"
          iconRight
          disabled={disableLimitTo}
          onClick={onClickLimitTo}
          className="e2e-limit-to">
          Limit to
        </ButtonWithIcon>
        <ButtonWithIcon
          size="small"
          sprite="ChevronRight"
          iconRight
          disabled={disableExclude}
          onClick={onClickExclude}
          className="e2e-exclude">
          Exclude
        </ButtonWithIcon>
      </div>
    </>
  ) : null;
}

DialogFooter.propTypes = {
  id: PropTypes.string.isRequired,
  filter: PropTypes.instanceOf(Map),
  chunksCount: PropTypes.number,
  onClickLimitTo: PropTypes.func.isRequired,
  onClickExclude: PropTypes.func.isRequired,
  disableLimitTo: PropTypes.bool,
  disableExclude: PropTypes.bool,
  setActiveChunkId: PropTypes.func.isRequired,
  onClickGoToButton: PropTypes.func.isRequired,
  activeChunkIndexAsInteger: PropTypes.number.isRequired,
  sortingType: PropTypes.oneOf([occurrence, byValue]).isRequired,
  customGroups: PropTypes.bool,
};

export default DialogFooter;
